<template>
  <a-spin :spinning="permissionLoad">
    <!-- 默认权限 -->
    <ul class="permission" style="margin-top: 10px" v-if="authType === 0">
      <li v-for="(item, index) in permission" :key="index">
        {{ item.fileTypeDesc }}:
        <select-member
          :userlist="item.users"
          :parentIndex="index"
          :canEdit="false"
          :canDeleteAll="false"
          :width="360"
          :abridged="6"
          :canExpand="true"
        ></select-member>
      </li>
    </ul>
    <!-- 自定义权限 -->
    <ul class="customPermission" style="margin-top: 10px" v-if="authType === 1">
      <li v-for="(customItem, index) in customPermission" :key="index">
        {{ customItem.fileTypeDesc }}:
        <select-member
          :userlist="customItem.users"
          :parentIndex="index"
          :canEdit="true"
          :canDeleteAll="true"
          :width="360"
          :abridged="5"
          :canExpand="true"
          @delChosenUser="delUserIds"
          @chose="choseUserIds"
          @delAllUsers="delAllUsers"
        ></select-member>
      </li>
    </ul>
  </a-spin>
</template>
<script>
import { fileFoldersDefaultPermission } from '@/api/document.js';
import selectMember from '@/components/project/selectMember';
export default {
  components: { selectMember },
  props: {
    fileId: {
      type: [String, Number],
      default: ''
    },
    authType: {
      type: [String, Number],
      default: 0
    }
  },
  data() {
    return {
      permissionLoad: false,
      tempEdit: '',
      permission: [], //默认权限
      customPermission: [] //自定义权限
    };
  },
  watch: {
    authType() {
      if (this.authType === 0) {
        this.getDefalutPermission();
      }
    }
  },
  methods: {
    clickDelUser(item, index) {
      this.$set(this.customPermission, index, {
        fileTypeDesc: item.fileTypeDesc,
        fileTypeId: item.fileTypeId,
        users: []
      });
    },
    choseUserIds(users, index) {
      this.$set(this.customPermission, index, {
        fileTypeDesc: this.customPermission[index].fileTypeDesc,
        fileTypeId: this.customPermission[index].fileTypeId,
        users: users
      });
      this.tempEdit = '';
    },
    delUserIds(user, index) {
      const item = this.customPermission[index];
      item.users = item.users.filter(_user => _user.id !== user.id);
    },
    delAllUsers(index) {
      const item = this.customPermission[index];
      item.users = [];
    },
    getDefalutPermission() {
      // 获取默认权限
      if (this.fileId || this.fileId === 0) {
        this.permissionLoad = true;
        let body = {
          fileId: this.fileId,
          type: this.authType
        };
        if (+this.authType === 1) {
          delete body.type;
        }
        fileFoldersDefaultPermission(body).then(res => {
          this.permission = res.data.list;
          if (!this.customPermission.length) {
            // this.authType = res.data.authType
            this.customPermission = res.data.list;
          }
          this.permissionLoad = false;
        });
      }
    }
  },
  mounted() {
    this.getDefalutPermission();
  }
};
</script>
